export const getCriteriaFromQuestions = (questions) => {
    return questions ? questions.reduce((criteria, question) => criteria.concat(question.access_criteria), []) : []
}